import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BarLinesChartModule } from '../bar-lines-chart/bar-lines-chart.module';
import { ReportTableModule } from '../report-table/report-table.module';
import { DashboardComponent } from './dashboard.component';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BarLinesChartModule,
    ReportTableModule,
    CommonTranslationModule,
    CommonUIModule
  ],
  declarations: [DashboardComponent]
})
export class DashboardModule { }
